/* eslint-disable indent */
const selectedAccount = (state = 0, action) => {
  switch (action.type) {
    case 'SET_CURRENT_SUPPORT_ACCOUNT_INDEX':
      return +action.id // ensure number
    default:
      return state
  }
}

export default selectedAccount
